import tokenApiService from '@/request/token/token.api.service';
import { useBoomWallet } from '@boomeme/wallet-sdk';
import BigNumber from 'bignumber.js';
import { useEffect, useState } from 'react';
import smartMoneyApiService from '@/request/smartMoney/smartMoney.api.service';

export interface IHoldingPriceBalance {
  unrealizedPnl: string;
  unrealizedRoi: string;
  tokenAddress: string;
  symbol: string;
  balance: string;
  price: string | number;
  priceChg: string;
  amount: string;
}

export const useHoldingData = () => {
  const [holdingList, setHoldingList] = useState<IHoldingPriceBalance[]>([]);
  const [loading, setLoading] = useState(false);
  const { walletAddress, chain } = useBoomWallet();

  const init = async () => {
    try {
      if (!walletAddress) return;
      setLoading(true);
      const res = await smartMoneyApiService.getAddressHolding({
        address: walletAddress,
        chain: chain == 'solana' ? 'sol' : 'bsc',
      });
      if (res.length === 0) {
        setHoldingList([]);
        return;
      }
      const filterList = res.filter((item) => BigNumber(item.totalBuyAmount).minus(item.totalSellAmount).gt(0.01));
      const addressList = filterList.map((item) => item.tokenAddress);
      const priceRes = await tokenApiService.getTokenPriceList(addressList);

      if (priceRes.code == 0) {
        const list: IHoldingPriceBalance[] = [];
        filterList.forEach((item) => {
          const holding = priceRes.data.find((token) => token.address.toLowerCase() === item.tokenAddress.toLowerCase());
          const amount = BigNumber(item.totalBuyAmount).minus(item.totalSellAmount);
          const balance = amount.times(item.curPrice).toString();
          list.push({
            unrealizedPnl: item.unRealizedPnL.toString(),
            unrealizedRoi: item.unRealizedRoi.toString(),
            tokenAddress: item.tokenAddress,
            balance,
            amount: amount.toString(),
            symbol: item.symbol,
            price: item.curPrice,
            priceChg: holding ? holding.priceChange24h : '0',
          });
        });
        setHoldingList(list);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    init();
  }, [walletAddress, chain]);

  return {
    holdingList,
    loading,
  };
};
